
import "./Statistica.css";
import React, { useState, useEffect } from "react";
import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

const  CustomTooltip = ({ payload } : { payload: any }) => {
    if (payload) {
        return (
            <div
                className = "custom-tooltip"
                style = {{
                    width: "auto",
                    height: "40px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#ffff",
                    padding: "5px 10px",
                    boxShadow: "0 0 5px rgba(0,0,0,0.5)",
                    borderRadius: "7px"
                }}
            >
                <label className = "circleChartValueText">{`Active : ${payload[0]?.value}`}</label>
            </div>
        );
    }
    return null;
};

function ActiveClientsChart({ activeClients, showDate } : { activeClients: any, showDate: string[] }) {

    const [activeClientsChartData, setActiveClientsChartData] = useState<Array<any>>();

    useEffect(() => {
        if (activeClients && showDate) {
            let arrChartData: any[] = new Array();
            showDate.forEach((date: string) => {
                const findDate = activeClients.find((active: any) => date === active.date.replaceAll("-", "/"))
                if (findDate) {
                    let obj = {
                        count: findDate.count,
                        date: date.slice(5).replace("/", ".") ,
                    }
                    arrChartData.push(obj);
                }
                else {
                    let obj = {
                        count: 0,
                        date: date.slice(5).replace("/", "."),
                    }
                    arrChartData.push(obj)
                }
            })
            setActiveClientsChartData(arrChartData);
        }
    }, [activeClients, showDate]);

    return(
        <div className = "ActiveClients">
            <span className = "activeClientsTitle">
                Clients
            </span>
            <ResponsiveContainer width = "100%" height = { 350 }>
                <LineChart
                    data = { activeClientsChartData }
                    style = {{
                        fontSize: "12px",
                        fontFamily: "'Poppins', sans-serif",
                        margin: 0,
                    }}
                >
                    <Line type = "monotone" dataKey = "count"  stroke = "#0044CC"/>
                    <CartesianGrid  vertical = { false } stroke = { "rgba(0,0,0,0.1)" }/>
                    <XAxis dataKey = "date"  stroke = { "#666666" }/>
                    <YAxis type = "number" stroke = { "#212121" } domain = { ["0", 'dataMax+50'] }/>
                    <Tooltip
                        content = { <CustomTooltip payload = { activeClients }/> }
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    )
}

export default ActiveClientsChart